import { defineI18n } from 'fumadocs-core/i18n';
import { defineI18nUI } from 'fumadocs-ui/i18n';

import { getFireflyCnUrl, getFireflyEnUrl } from '@/shared/api/firefly-api';

export const i18n = defineI18n({
  languages: ['zh', 'en'],
  defaultLanguage: 'zh',
  hideLocale: 'default-locale',
  parser: 'dir',
});

export type Locale = (typeof i18n.languages)[number];

export const localeNames: Record<Locale, string> = {
  zh: '中文',
  en: 'English',
};

export const localeHtmlLang: Record<Locale, string> = {
  zh: 'zh-CN',
  en: 'en',
};

export const i18nUI = defineI18nUI(i18n, {
  zh: {
    displayName: localeNames.zh,
    'Choose a language(language switcher)': '选择语言',
    'Choose a language(language switcher)(aria-label)': '选择语言',
    'Close Search(search dialog)(aria-label)': '关闭搜索',
    'No results found(search dialog)': '未找到结果',
    'On this page(table of contents)': '本页目录',
    'Next Page(pagination)': '下一页',
    'Previous Page(pagination)': '上一页',
    'Search(search dialog)': '搜索',
  },
  en: {
    displayName: localeNames.en,
  },
});

export function isLocale(value: string): value is Locale {
  return i18n.languages.includes(value as Locale);
}

export function getLocalizedPath(path: string, locale?: Locale): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (!locale || locale === i18n.defaultLanguage) {
    return normalizedPath;
  }

  if (normalizedPath === '/') return `/${locale}`;
  return `/${locale}${normalizedPath}`;
}

export function getFireflyOfficialHomeUrl(locale: Locale): string {
  const officialBaseUrl = locale === 'zh' ? getFireflyCnUrl() : getFireflyEnUrl();

  return `${officialBaseUrl}/`;
}

export function stripLocale(pathname: string) {
  const segments = pathname.split('/');
  const maybeLocale = segments[1];

  if (maybeLocale && isLocale(maybeLocale)) {
    const path = `/${segments.slice(2).join('/')}`.replace(/\/+$/, '') || '/';

    return {
      locale: maybeLocale,
      path,
    };
  }

  return {
    locale: i18n.defaultLanguage,
    path: pathname,
  };
}
